/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
    // フォントサイト変更
    growApp.prototype.fontSizeChanger = function () {
      var targetButton = $('.l-header__variable-button');

      // 文字サイズ変更のボタンをクリックした時の処理
      targetButton.on('click', function () {
        $('html').removeClass("u-font-sm");
        $('html').removeClass("u-font-md");
        $('html').removeClass("u-font-lg");
        // 初期化
        targetButton.removeClass('is-current');
        // クリックしたボタンのクラス取得
        var targetButtonClass = $(this).attr('class');
        // 「小」のボタンをクリックした時の処理
        if (targetButtonClass === 'l-header__variable-button is-small') {
          sessionStorage.setItem('font-size', 'small');
          $(this).addClass('is-current');
          $('html').addClass("u-font-sm");
        }
        // 「中」のボタンをクリックした時の処理
        if (targetButtonClass === 'l-header__variable-button is-defalut') {
          sessionStorage.setItem('font-size', 'defalut');
          $(this).addClass('is-current');
          $('html').addClass("u-font-md");
        }
        // 「大」のボタンをクリックした時の処理
        if (targetButtonClass === 'l-header__variable-button is-large') {
          sessionStorage.setItem('font-size', 'large');
          $(this).addClass('is-current');
          $('html').addClass("u-font-lg");
        }
      });


      // ローカルストレージにあるfont-sizeキーを取得
      var storageSize = sessionStorage.getItem('font-size');

      // 初期化
      targetButton.removeClass('is-current');

      // ローカルストレージに値がない場合、「中」にする
      if (!storageSize) {
        $('.l-header__variable-button.is-defalut').addClass('is-current');
      }
      // ローカルストレージの値が small の場合、「小」にする
      if (storageSize === 'small') {
        $('.l-header__variable-button.is-small').addClass('is-current');
        $('html').addClass("u-font-sm");
      }
      // ローカルストレージの値が defalut の場合、「中」にする
      if (storageSize === 'defalut') {
        $('.l-header__variable-button.is-defalut').addClass('is-current');
        $('html').addClass("u-font-md");
      }
      // ローカルストレージの値が large の場合、「小」にする
      if (storageSize === 'large') {
        $('.l-header__variable-button.is-large').addClass('is-current');
        $('html').addClass("u-font-lg");
      }
    }
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.fontSizeChanger();
  });
})(jQuery);
